// Menu
$(function() {
    // Submenu hide/show on scroll
    const body = document.body;
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;
    const searchForm = document.querySelector('.blogmenu__submenu__search');
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll <= 0) {
            body.classList.remove(scrollUp);
            return;
        }
        
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // Down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // Up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }

        lastScroll = currentScroll;
    });

    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const input = searchForm.querySelector('input.blogmenu__submenu__search__input');
            if (input.value.length > 0) {
                window.location = `/search/${input.value}`;
            }
        });
    }

    // Menu toggle
    function toggleMenu() {
        const overlay = $("#menu_overlay");
        const burgerIcon = $(".menu__burger__wrapper");
        const doc = $("body");
        const menu = $("#menu");
        const windowpos = $(window).scrollTop();
        
        if (overlay.attr('aria-expanded') == "true") {
            doc.css("margin-top", -{windowpos}).removeClass('scroll-lock');
            burgerIcon.removeClass('menu__burger__wrapper--active');
            overlay.attr('aria-expanded', false).removeClass('menu__overlay--active');
            menu.removeClass('menu--open');
        } else {
            doc.css("margin-top", "").addClass('scroll-lock');
            burgerIcon.addClass('menu__burger__wrapper--active');
            overlay.attr('aria-expanded', true).addClass('menu__overlay--active');
            menu.addClass('menu--open');
        }
    }
    $('.menu__burger__wrapper').on('click', function() {
        toggleSubMenu(false);
        toggleMenu();
    });

    // Submenu toggle
    function toggleSubMenu(state = null) {
        const overlay = $("#blogmenu_overlay");
        const burgerIcon = $(".blogmenu__button");
        const doc = $("body");
        const windowpos = $(window).scrollTop();
        const open = state != null ? !state : overlay.attr('aria-expanded') == "true";
        
        if (open) {
            doc.css("margin-top", -{windowpos}).removeClass('scroll-lock');
            burgerIcon.removeClass('blogmenu__button--active');
            overlay.attr('aria-expanded', false).removeClass('blogmenu__overlay--active');
        } else {
            doc.css("margin-top", "").addClass('scroll-lock');
            burgerIcon.addClass('blogmenu__button--active');
            overlay.attr('aria-expanded', true).addClass('blogmenu__overlay--active');
        }
    }
    $('.blogmenu__button').on('click', function(e) {
        toggleSubMenu();
    });
    $('#blogmenu_overlay').on('click', function(e) {
        if ($(e.target).is('#blogmenu_overlay')) {
            toggleSubMenu();
        }
    });

    function toggleMobileChildMenuCollapse(target) {
        const toggleElement = target;
        const childMenu = target.parentNode.getElementsByClassName('menu_submenu__subitems')[0];
        
        if (toggleElement.classList.contains('menu_submenu__item__toggle--active')) {
            toggleElement.classList.remove('menu_submenu__item__toggle--active');
            childMenu.classList.remove('menu_submenu__subitems--visible');
        } else {
            toggleElement.classList.add('menu_submenu__item__toggle--active');
            childMenu.classList.add('menu_submenu__subitems--visible');
        }
    }
    $('.menu_submenu__item__toggle').on('click', function(e) {
        toggleMobileChildMenuCollapse(e.currentTarget);
    });
});